import { render, staticRenderFns } from "./ContractsOverviewTab.vue?vue&type=template&id=004dcefc&scoped=true"
import script from "./ContractsOverviewTab.vue?vue&type=script&lang=js"
export * from "./ContractsOverviewTab.vue?vue&type=script&lang=js"
import style0 from "./ContractsOverviewTab.vue?vue&type=style&index=0&id=004dcefc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004dcefc",
  null
  
)

export default component.exports